const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return null; // Invalid date
    return date.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  };
  
  // Helper function to format date to YYYYMMDD
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    return date.toISOString().slice(0, 10).replace(/-/g, '');
  };
  
  export const generateQRContent = (qrType, row, mappedFields) => {
    switch (qrType) {
      case "plain_text": {
        // Handle plain text with multiple columns
        if (!mappedFields.columns || mappedFields.columns.length === 0) {
          return "";
        }
        
        const separator = mappedFields.separator || ',';
        return mappedFields.columns
          .map(column => row[column])
          .filter(value => value !== undefined && value !== null)
          .join(separator);
      }
  
      case "email": {
        const email = row[mappedFields.email];
        const subject = mappedFields.subject ? row[mappedFields.subject] : '';
        const body = mappedFields.body ? row[mappedFields.body] : '';
        
        let mailtoUrl = `mailto:${email}`;
        const params = [];
        
        if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
        if (body) params.push(`body=${encodeURIComponent(body)}`);
        
        if (params.length > 0) {
          mailtoUrl += '?' + params.join('&');
        }
        
        return mailtoUrl;
      }
  
      case "contact": {
        const name = row[mappedFields.name] || '';
        const phone = row[mappedFields.phone] || '';
        const email = row[mappedFields.email] || '';
        
        // Use proper line endings and escape special characters
        return [
          'BEGIN:VCARD',
          'VERSION:3.0',
          `N:${name.replace(/[;,]/g, '')}`,
          phone ? `TEL:${phone.replace(/[;,]/g, '')}` : '',
          email ? `EMAIL:${email.replace(/[;,]/g, '')}` : '',
          'END:VCARD'
        ].filter(line => line).join('\n');
      }
  
      case "calendar": {
        const title = row[mappedFields.title];
        const startDate = formatDateTime(row[mappedFields.start_date]);
        const endDate = formatDateTime(row[mappedFields.end_date]);
  
        if (!title || !startDate || !endDate) {
          console.error("Invalid calendar data:", { title, startDate, endDate });
          return "Invalid calendar data";
        }
  
        // Use proper line endings and escape special characters
        return [
          'BEGIN:VEVENT',
          `SUMMARY:${title.replace(/[;,]/g, '')}`,
          `DTSTART:${startDate}`,
          `DTEND:${endDate}`,
          'END:VEVENT'
        ].join('\n');
      }
  
      case "product": {
        const productData = {
          name: row[mappedFields.product_name],
          sku: row[mappedFields.product_id],
          description: row[mappedFields.description],
          category: row[mappedFields.category],
          brand: row[mappedFields.brand]
        };

        // Filter out undefined or null values
        const cleanData = Object.fromEntries(
          Object.entries(productData).filter(([_, value]) => value != null && value !== undefined)
        );

        // Return JSON string of the product data
        return JSON.stringify(cleanData);
      }

      case "pricing_inventory": {
        const inventoryData = {
          price: parseFloat(row[mappedFields.price]),
          currency: row[mappedFields.currency],
          quantity: parseInt(row[mappedFields.quantity]),
          batch_number: row[mappedFields.batch_number],
        };

        // Filter out undefined or null values
        const cleanData = Object.fromEntries(
          Object.entries(inventoryData).filter(([_, value]) => value != null && value !== undefined)
        );

        // Return JSON string of the inventory data
        return JSON.stringify(cleanData);
      }

      case "tracking_logistics": {
        const trackingData = {
          serial_number: row[mappedFields.serial_number],
          barcode: row[mappedFields.barcode],
          expiration_date: row[mappedFields.expiration_date] ? formatDate(row[mappedFields.expiration_date]) : undefined,
          manufacturing_date: row[mappedFields.manufacturing_date] ? formatDate(row[mappedFields.manufacturing_date]) : undefined,
          shipping_info: row[mappedFields.shipping_info]
        };

        // Filter out undefined or null values
        const cleanData = Object.fromEntries(
          Object.entries(trackingData).filter(([_, value]) => value != null && value !== undefined)
        );

        // Return JSON string of the tracking data
        return JSON.stringify(cleanData);
      }
  
      default:
        return "";
    }
  };
  